import { render, staticRenderFns } from "./DataImplementationEditor.vue?vue&type=template&id=383036a7&scoped=true&"
import script from "./DataImplementationEditor.vue?vue&type=script&lang=js&"
export * from "./DataImplementationEditor.vue?vue&type=script&lang=js&"
import style0 from "./DataImplementationEditor.vue?vue&type=style&index=0&id=383036a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383036a7",
  null
  
)

export default component.exports